/* =====================================================================
   Superette × Fish Wishlist v2 — follow brands (v1.4, Wishlist V3: following just fills the bookmark, no drawer)
   ⚠ JavaScript. Never paste into the Fish Wishlist Custom CSS box.
   · PDP: one small, quiet "Follow {Brand}" + bookmark on the brand line at the top of the product
     info (no helper line, no extra row, nothing in the buy area). Collection pages are unchanged. It's Fish's saved-collection button for
     the brand's own collection (window.spBrand from snippets/wishlist-redirect.liquid).
   · Everywhere (PDP + brand collection title): following / unfollowing a brand is also sent to
     Klaviyo as "Followed Brand" / "Unfollowed Brand" (Brand, CollectionId, CollectionUrl) so a
     "new arrivals from brands you follow" flow can deliver on the promise in the helper line.
   ===================================================================== */
(() => {
  const KLAVIYO = { companyId: 'SuDUu6', revision: '2024-10-15' };
  const me = window.spWishlist || {};
  const brand = window.spBrand;
  const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- PDP: Follow on the brand line ---------- */
  const place = () => {
    if (!brand || !brand.id) return;
    const host = document.querySelector('product-info .cis__vendor-header');
    if (!host || host.querySelector('.sp-brand-follow')) return;
    const wrap = document.createElement('div');
    // built with every attribute in place: Fish reads them when the element is created
    wrap.innerHTML = `<wishlist-button-collection role="button" tabindex="0" class="fish-wishlist-button--collection sp-save-collection sp-brand-follow" data-collection-id="${String(brand.id).replace(/[^\d]/g, '')}" data-sp-label="Follow" data-sp-brand="${esc(brand.title)}" data-sp-url="${esc(brand.url)}" aria-label="Follow ${esc(brand.title)}"></wishlist-button-collection>`;
    // the label reads "Follow Anine Bing" / "Following Anine Bing" (CSS reads the name from --sp-brand)
    wrap.firstElementChild.style.setProperty('--sp-brand', JSON.stringify(String(brand.title || '')));
    host.classList.add('sp-has-follow');
    host.append(...wrap.children);
  };

  /* ---------- Klaviyo: Followed / Unfollowed Brand ---------- */
  const track = (name, btn) => {
    if (!me.loggedIn || !me.email) return;
    fetch(`https://a.klaviyo.com/client/events/?company_id=${KLAVIYO.companyId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO.revision },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties: { Brand: btn.dataset.spBrand, CollectionId: btn.dataset.collectionId, CollectionUrl: btn.dataset.spUrl || '' },
            metric: { data: { type: 'metric', attributes: { name } } },
            profile: { data: { type: 'profile', attributes: { email: me.email } } },
          },
        },
      }),
    }).catch(() => {});
  };
  // only a change the shopper made (a click), not Fish loading the saved state
  const armed = new WeakMap();
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('wishlist-button-collection[data-sp-brand]');
    if (btn) armed.set(btn, { was: btn.dataset.isAdded === 'true', until: Date.now() + 8000 });
  }, true);
  new MutationObserver((muts) => {
    muts.forEach((m) => {
      const btn = m.target;
      const a = armed.get(btn);
      if (!a || Date.now() > a.until) return;
      const now = btn.dataset.isAdded === 'true';
      if (now === a.was) return;
      armed.delete(btn);
      track(now ? 'Followed Brand' : 'Unfollowed Brand', btn);
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['data-is-added'] });

  const init = () => { place(); setTimeout(place, 1200); };
  /* ---------- V3 · following a brand just fills the bookmark — no drawer slides out, no toast ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('wishlist-button-collection');
    if (!b || !me.loggedIn) return;
    const root = document.documentElement;
    root.dataset.spSilent = 'true'; // hides Fish's drawer + toast while it saves (sp-notify-me.css)
    const end = Date.now() + 1500;
    const shut = setInterval(() => {
      document.querySelectorAll('fw2-drawer').forEach((d) => { if (d.dataset.open === 'true' && typeof d.close === 'function') d.close(); });
      if (Date.now() > end) { clearInterval(shut); delete root.dataset.spSilent; }
    }, 80);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
